<div
  class="flex h-full flex-col justify-between gap-4 rounded-lg border border-dashed border-grey-lightGrey bg-grey-veryLightGrey px-4 py-5"
>
  <div>
    <div class="flex items-center gap-3">
      @if (hrisIntegrationDataService.providers.length) {
        <div class="flex items-center">
          @for (
            provider of hrisIntegrationDataService.providers;
            track provider.name;
            let i = $index
          ) {
            @if (i < hrisIntegrationDataService.showProviders) {
              <div
                class="size-7 overflow-hidden rounded-full bg-white p-1 shadow-lg"
                [title]="provider.name"
                [class]="i === 0 ? '' : '-ml-3'"
              >
                <img
                  [src]="provider.logoUrl"
                  [alt]="provider.name"
                  [height]="20"
                  [width]="20"
                />
              </div>
            }
            @if (i === hrisIntegrationDataService.showProviders) {
              <div
                class="-ml-3 flex size-7 items-center justify-center rounded-full bg-white text-sm font-semibold text-blue-dark shadow-lg"
              >
                +{{
                  hrisIntegrationDataService.providers.length -
                    hrisIntegrationDataService.showProviders
                }}
              </div>
            }
          }
        </div>
      }
      <p class="text-base/7 font-semibold text-blue-dark">
        {{ 'portal.hrisIntegration.setupCard.title' | transloco }}
      </p>
    </div>
    <p class="text-base font-normal text-grey">
      {{ 'portal.hrisIntegration.setupCard.text' | transloco }}
    </p>
  </div>
  <app-secondary-button
    [text]="'portal.hrisIntegration.setupCard.button' | transloco"
    [loading]="hrisIntegrationDataService.isCreatingHRISIntegration"
    [disabled]="hrisIntegrationDataService.isLoadingHRISIntegration"
    (buttonClicked)="handleButtonClick()"
  />
</div>
